module.exports = "https://www.gc-pro.gnp.com.mx/a6d735aae37e68f369078273f814c2f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/directorio/6.png
// module id = 1027
// module chunks = 0 1